import Styled from 'styled-components'

export const Error = Styled.div`
    svg {
        width: 100px;
        height: 100px;
        color: #ffc107;
    }
`;
